import { Box, Container } from "@mui/material";
import React from "react";
import CustomText from "../../customComponents/customText";
import { translation } from "../../assets/translation";
import { language } from "../../assets/function";
import { Colors } from "../../assets/colors";
import { motion } from "framer-motion";

function Hiring() {
  let staticText = translation[language];

  React.useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://static.zohocdn.com/recruit/embed_careers_site/javascript/v1.1/embed_jobs.js";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      window.rec_embed_js.load({
        widget_id: "rec_job_listing_div",
        page_name: "Careers",
        source: "CareerSite",
        site: "https://andaiplatforms.zohorecruit.in",
        brand_color: "#fe5243",
        empty_job_msg: "No current Openings",
      });
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Box sx={styles.container}>
      <Container maxWidth="xl" sx={styles.containerStyle}>
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <Box sx={{}}>
            <CustomText
              desc={staticText.weAreHiring}
              fontFamily="Epilogue"
              colorvalue={Colors.andaihubTxt}
              style={{ ...styles.coreFeatureTxt }}
              title3
              fontWeight={400}
            />
          </Box>

          <Box
            sx={{
              width: "100%",
              justifyContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <link
              rel="stylesheet"
              href="https://static.zohocdn.com/recruit/embed_careers_site/css/v1.1/embed_jobs.css"
              type="text/css"
            />
            <div
              className="embed_jobs_head embed_jobs_with_style_3"
              style={{ backgroundColor: Colors.themeColor }}
            >
              <div className="embed_jobs_head2">
                <div className="embed_jobs_head3">
                  <div id="rec_job_listing_div"></div>
                </div>
              </div>
            </div>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
}
const styles = {
  headText: {
    lineHeight: 1.4,
    fontStyle: "initial",
  },
  descText: {
    lineHeight: 1.5,
    fontStyle: "initial",
  },
  coreFeatureSubBox: {
    width: "50%",
    marginBottom: 1.3,
    objectFit: "cover",
    borderRadius: 4,
    display: "flex",
    backgroundColor: Colors.white,
    borderWidth: 0,
    pl: 4,
    pr: 4,
    pt: 3.5,
    pb: 3.5,
  },
  coreSecondBox: {
    display: "grid",
    flexDirection: "column",
  },
  coreFeatureBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 2,
    flexWrap: "wrap",
    width: "100%",
  },
  container: {
    paddingTop: {
      xs: 6,
      sm: 7,
      md: 9,
      lg: 10,
      xl: 11
    },
    paddingBottom: {
      xs: 6,
      sm: 8,
      md: 10,
      lg: 11,
      xl: 13
    },
    backgroundColor: Colors.themeColor,
  },

  containerStyle: {},
  coreFeatureTxt: {
    lineHeight: 1,
    fontStyle: "initial",
    textTransform: "none",
    textAlign: "center",
    paddingBottom: {
      xs: 3,
      sm: 4,
      md: 5,
      lg: 6,
      xl: 7,
    },
  },
};

export default Hiring;
